import {ApiService} from './api.service';
let apiService = new ApiService();

export const AuthenticateService = {
  login,
};

function login(username, password) {
  return apiService.post('public/v1/authenticate/login', { username, password });
}